import React from 'react';

export const RangeSliderInputWrapper: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <div className={'flex max-w-full px-6 h-[44px]'}>{children}</div>
);

export const RANGE_SLIDER_BLUE = '#1C47CA';
export const RANGE_SLIDER_LABEL_BG = '#F5F6FA';
export const RANGE_SLIDER_RAILING_BG = '#D6D8D9';

export const RANGE_SLIDER_EXTRA_CSS = {
  height: '2px',
  color: RANGE_SLIDER_BLUE,
} as const;

export const RANGE_SLIDER_LABEL_EXTRA_CSS = {
  transform: 'translateY(0%) scale(1)',
  backgroundColor: RANGE_SLIDER_LABEL_BG,
  borderRadius: '8px',
  color: RANGE_SLIDER_BLUE,
  fontFamily: 'Karla',
  fontSize: '12px',
  fontWeight: 700,
  lineHeight: '150%',
  padding: '0 4px',
  boxShadow: '0px 2px 4px 0px rgba(41, 45, 51, 0.08)',
  top: '22px',
} as const;

export const RANGE_SLIDER_THUMB_EXTRA_CSS = {
  backgroundColor: RANGE_SLIDER_BLUE,
  boxShadow: 'none !important',
} as const;

export const RANGE_SLIDER_RAILING_EXTRA_CSS = {
  backgroundColor: RANGE_SLIDER_RAILING_BG,
  boxShadow: 'none',
  opacity: '1',
} as const;

export const RANGE_SLIDER_TRACK_EXTRA_CSS = {
  backgroundColor: RANGE_SLIDER_BLUE,
  boxShadow: 'none',
} as const;

// the rules below were all captured from inspection of the MUI component
export const RANGE_SLIDER_MUI_DEFAULT_RULES = {
  borderRadius: '12px',
  boxSizing: 'content-box',
  display: 'inline-block',
  position: 'relative',
  cursor: 'pointer',
  touchAction: 'none',
  WebkitTapHighlightColor: 'transparent',
  color: '#1976d2',
  width: '100%',
  padding: '13px 0',
  userSelect: 'none',
} as const;

export const RANGE_SLIDER_RAILING_MUI_DEFAULT_RULES = {
  display: 'block',
  position: 'absolute',
  borderRadius: 'inherit',
  width: '100%',
  height: 'inherit',
  top: '50%',
  transform: 'translateY(-50%)',
} as const;

export const RANGE_SLIDER_TRACK_MUI_DEFAULT_RULES = {
  display: 'block',
  position: 'absolute',
  borderRadius: 'inherit',
  border: '1px solid currentColor',
  transition:
    'left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, width 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, bottom 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, height 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  height: 'inherit',
  top: '50%',
  transform: 'translateY(-50%)',
} as const;

export const RANGE_SLIDER_THUMB_MUI_DEFAULT_RULES = {
  position: 'absolute',
  width: '20px',
  height: '20px',
  boxSizing: 'border-box',
  borderRadius: '50%',
  outline: '0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition:
    'box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, bottom 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  top: '50%',
  transform: 'translate(-50%, -50%)',
} as const;

export const RANGE_SLIDER_LABEL_MUI_DEFAULT_RULES = {
  zIndex: '1',
  whiteSpace: 'nowrap',
  letterSpacing: '0.01071em',
  transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transformOrigin: 'bottom center',
} as const;
